import { takeLatest, put, call } from 'redux-saga/effects';
import UnitActions, { UnitTypes } from '../Redux/UnitRedux';
import ApiResponseError from '../Services/ApiResponseError';

export function * getUnits(api) {
    try {
        const response = yield call(api.getUnits);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        const { units } = response.data.data;
        yield put(UnitActions.fetchUnitsSuccess(units));
    } catch (e) {
        yield put(UnitActions.fetchUnitsFailure(e));
    }
}

export function * createUnit(api, {unit}) {
    try {
        const response = yield call(api.createUnit, unit);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(UnitActions.createUnitSuccess(response.data.data.unit));
    } catch (e) {
        yield put(UnitActions.createUnitFailure(e));
    }
}

export function * deleteUnit(api, {id, query}) {
    try {
        const response = yield call(api.deleteUnit, id, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(UnitActions.deleteUnitSuccess());
        yield call(getUnits, api, {query});
    } catch (e) {
        yield put(UnitActions.deleteUnitFailure(e));
    }
}

export function * watchUnit(api) {
    yield takeLatest(UnitTypes.FETCH_UNITS, getUnits, api);
    yield takeLatest(UnitTypes.CREATE_UNIT, createUnit, api);
    yield takeLatest(UnitTypes.DELETE_UNIT, deleteUnit, api);
}



// WEBPACK FOOTER //
// ./src/Sagas/UnitSagas.js